import React, { useEffect } from 'react';
import { useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { ISecondaryEmail } from '../../Models/ISecondaryEmail';
import { ISupplier } from '../../Models/ISupplier';
import { } from '../../Services/fetchApi';
import useFetch from '../../Services/useFetch';
import useFetchSimple from '../../Services/useFetchSimple';
import { endpoints } from '../../utils/Constants';
import entities from '../../utils/entities';
import Modal from '../Models/Modal';

interface props {
    supplier: ISupplier;
    open: boolean;
    onClose?: () => void;
}

const SecondaryEmail = ({ supplier, secondaryAddress, removeEmail }: {
    supplier: ISupplier, secondaryAddress: string,
    removeEmail: (secondary: ISecondaryEmail) => Promise<void>
}) => {
    return <Row>
        <Col>{secondaryAddress}</Col>
        <Col><Button onClick={async () => await removeEmail({ supplierId: supplier.id, email: secondaryAddress })}>Remove Email</Button></Col>
    </Row>
}

const SecondaryEmails = ({ supplier, ...rest }: props) => {
    const [add, setAdd] = useState(false);
    const [serverEmails, loading, error] = useFetch(entities.supplierSecondaryEmails.getBySupplier({ id: supplier.id }));
    const [emails, setEmails] = useState([] as string[]);
    const fetch = useFetchSimple();
    const postReq = async (url: string, secondary: ISecondaryEmail) => {
        return await fetch(url, { method: "POST", body: JSON.stringify(secondary) });
    }
    useEffect(() => {
        if (!loading && !error && serverEmails instanceof Array) {
            setEmails(serverEmails);
        }
    }, [serverEmails, loading, error]);

    return <Modal {...rest} title={supplier.companyName}>
        <Container>
            {(!loading && !error) ? emails.map(email => <SecondaryEmail key={email} supplier={supplier} secondaryAddress={email}
                removeEmail={async () => {
                    // Remove the email from the database
                    await postReq(endpoints.removeSecondaryEmail, { supplierId: supplier.id, email });
                    // Remove the email from the open frontend
                    setEmails(emails.filter(address => address !== email));
                }
                }
            />) : null}
        </Container>
        <form onSubmit={async (event) => {
            event.preventDefault();
            const newSecEmail = { email: (event as any).target[0].value, supplierId: supplier.id };
            await postReq(endpoints.addSecondaryEmail, newSecEmail);
            // Add the new email to the list of secondary emails
            setEmails(emails.concat(newSecEmail.email));
            setAdd(false);
        }}>
            {add ? <input /> : null}
            {add ?
                <React.Fragment>
                    <Button type="submit">Add</Button>
                    <Button onClick={() => { setAdd(false); }}>Cancel</Button>
                </React.Fragment> :
                <Button onClick={() => { setAdd(true) }}>New</Button>}
        </form>
    </Modal >
}

export default SecondaryEmails;